// extracted by mini-css-extract-plugin
module.exports = {"component":"header-carousel-navigation_component__8OlbT","navigation":"header-carousel-navigation_navigation__TGey9"};